import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import { Login } from './pages';
import './shared/forms/TraducoesYup';
import { AppRoutes } from "./routes";
import { GlobalApiLoader, SideBar } from "./shared/components";
import { useAuthContext } from './shared/contexts/AuthContext';
import {
  AuthProvider,
  DrawerProvider,
  AppThemeProvider
} from "./shared/contexts";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { isAuthenticated, isSessionValidated } = useAuthContext();

  if (!isSessionValidated) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

const SessionAwareLoader = () => {
  const { isSessionValidated } = useAuthContext();
  return <GlobalApiLoader forceVisible={!isSessionValidated} />;
};

export const App = () => {
  return (
    <AuthProvider>
      <AppThemeProvider>
        <SessionAwareLoader />
        <DrawerProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <SideBar>
                      <AppRoutes />
                    </SideBar>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </DrawerProvider>
      </AppThemeProvider>
    </AuthProvider>
  );
};
